import { useState, useEffect, useRef } from 'react';

// Window resize

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}

// Component visible

export const useComponentVisible = (setState, state) => {
  const [isComponentVisible, setIsComponentVisible] =
    useState(state);
  const ref = useRef();

  const handleHideDropdown = (event) => {
    if (state && event.key === "Escape") {
     return setState(!state);
    }
  };

  const handleClickOutside = (event) => {
    if (state && ref.current && !ref.current.contains(event.target)) {
      return setState(!state);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown,true);
    document.addEventListener("click", handleClickOutside,true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown,true);
      document.removeEventListener("click", handleClickOutside,true);
    };
  });
  return { ref, isComponentVisible, setIsComponentVisible };
}

